import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Nav, NavItem, Badge, Alert } from 'reactstrap';
import { Btn, H5 } from '../../../AbstractElements';
import useShowClass from '../../../Hooks/useShowClass';
import TransactionTable from './TransactionTable';
import { getUsers } from '../../../api/userCheckIn';

const Transactions = () => {
  const NavTab = ['All', 'Followed', 'Not Followed'];
  const [active, setActive] = useState('All');
  const [show, setShow] = useShowClass('show');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const activeHandler = (item) => {
    setActive(item);
    setShow('');
  };

  // Fetch users from API
  useEffect(() => {
    const fetchUsersData = async () => {
      try {
        setLoading(true);
        const response = await getUsers({ page: 1, limit: 20 });
        
        // Ensure userData is always an array
        let userData = [];
        if (response?.data?.users && Array.isArray(response.data.users)) {
          userData = response.data.users;
        } else if (response?.data && Array.isArray(response.data)) {
          userData = response.data;
        } else if (response?.users && Array.isArray(response.users)) {
          userData = response.users;
        } else if (Array.isArray(response)) {
          userData = response;
        }
        
        // Transform user data to transaction format
        const transactionData = userData.map(user => ({
          title: user.followedOA ? 'Followed OA' : 'Not Followed',
          subTitle: new Date(user.createdAt || Date.now()).toLocaleDateString('en-GB'),
          price: user.name || 'Unknown',
          coins: user.phone || 'N/A',
          totalPrice: user.pharmacyName || 'No pharmacy',
          trend: user.followedOA ? 'up' : 'down',
          userId: user.userId,
          followedOA: user.followedOA
        }));
        
        setUsers(transactionData);
        setError(null);
      } catch (err) {
        console.error('Error fetching users in Transactions:', err);
        setError(err.message || 'Failed to load users');
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUsersData();
  }, []);

  return (
    <Card className='tranaction-card'>
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <H5>
            User Activities
            {users.length > 0 && (
              <Badge color='light-primary' className='ms-2'>
                {users.length}
              </Badge>
            )}
          </H5>
          <Nav tabs className='custom-tab'>
            {NavTab.map((item, i) => (
              <NavItem key={i}>
                <Btn attrBtn={{ color: 'transparent', onClick: (e) => activeHandler(item), className: `nav-link ${active === item && 'active'}` }}>{item}</Btn>
              </NavItem>
            ))}
          </Nav>
        </div>
      </CardHeader>
      <CardBody className='pt-0'>
        {loading ? (
          <div className='text-center p-3'>
            <div className='spinner-border text-primary spinner-border-sm' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : error ? (
          <Alert color='danger' className='m-3'>
            <i className='fa fa-exclamation-triangle me-2'></i>
            {error}
          </Alert>
        ) : users.length === 0 ? (
          <Alert color='info' className='m-3'>
            <i className='fa fa-info-circle me-2'></i>
            No user activities found. Please check your API connection.
          </Alert>
        ) : (
          <div className={`fade ${show} table-responsive recent-table transaction-table`}>
            <TransactionTable filterCoins={active} tableData={users} isUserData={true} />
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default Transactions;
